import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Check if user is logged in
    const token = api.getToken();
    const storedUser = localStorage.getItem('user');

    if (token && storedUser) {
      try {
        const userData = JSON.parse(storedUser);
        setUser(userData);
        setIsAuthenticated(true);
      } catch (error) {
        console.error('Error parsing user data:', error);
        api.setToken(null);
      }
    } else {
      // No token found - user needs to login
      setUser(null);
      setIsAuthenticated(false);
    }

    setLoading(false);
  }, []);

  const login = async (credentials) => {
    try {
      const response = await api.login(credentials);
      if (response.success && response.accessToken) {
        setUser(response.user || {
          id: response.user?.id,
          name: response.user?.firstName && response.user?.lastName 
            ? `${response.user.firstName} ${response.user.lastName}` 
            : response.user?.email || 'Admin',
          email: response.user?.email,
          role: response.user?.userType === 'admin' ? 'أدمن' : response.user?.userType
        });
        setIsAuthenticated(true);
        localStorage.setItem('user', JSON.stringify(response.user || {}));
        return { success: true };
      }
      return { success: false, message: response.message || 'فشل تسجيل الدخول' };
    } catch (error) {
      return { success: false, message: error.message || 'حدث خطأ أثناء تسجيل الدخول' };
    }
  };

  const logout = async () => {
    try {
      await api.logout();
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      setUser(null);
      setIsAuthenticated(false);
      localStorage.removeItem('user');
    }
  };

  const value = {
    user,
    loading,
    isAuthenticated,
    login,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

